import getTranslation from "@components/RecipeGrid/util/getTranslation";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "../style.module.scss";
import { IngredientsType } from "../types/RecipeProps";
import { Container } from "./Container";

export const IngredientsList = (props: { ingredients: IngredientsType[] }): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();
    const { t } = useTranslation();

    const { ingredients } = props;

    return (
        <Container>
            <div className={style.headerLabel}>
                <Typography
                    variant="h2"
                    color="dark"
                    size={jnjFullBranded ? "2xl" : "3xl"}
                    font="title"
                    weight={jnjFullBranded ? "400" : "500"}
                >
                    {t("Ingredients", { ns: "recipe" })}
                </Typography>
            </div>
            <ul className={style.unorderedRecipeList}>
                {ingredients?.map(
                    (ingredient: { ingredient: { amount: string; name: string; unit: string } }, index: number) => {
                        const unit = ingredient?.ingredient?.unit !== null ? ingredient?.ingredient?.unit : "";

                        return (
                            <li key={`ingredient-${index}`}>
                                {jnjFullBranded ? (
                                    <Typography variant="body-02">
                                        {`${ingredient?.ingredient?.amount} ${getTranslation(unit, t)} ${
                                            ingredient?.ingredient?.name
                                        }`}
                                    </Typography>
                                ) : (
                                    `${ingredient?.ingredient?.amount} ${getTranslation(unit, t)} ${
                                        ingredient?.ingredient?.name
                                    }`
                                )}
                            </li>
                        );
                    },
                )}
            </ul>
        </Container>
    );
};
